<h1>Brose nutzt video2manual</h1>
<section class="article">
  <article>
    <div class="text">
      <p>
        Der schnellste Weg von der Idee zur Video-Anleitung ist video2manual.
      </p>
      <p>
        Das sagt auch unser langjähriger Kunde, Brose Fahrzeugteile GmbH & Co.
        KG. Jens Makareinis berichtet im Folgenden von den Erfolgen durch die
        Einführung unserer Software video2manual und wie sie im
        Unternehmensalltag eingesetzt wird.
      </p>
      <img src="assets/brose_meets_v2m.png" style="width: 300px;" />
      <p>
        Brose ist weltweit der viertgrößte Automobilzulieferer in
        Familienbesitz. Das Unternehmen entwickelt und fertigt sowohl
        mechatronische Systeme für Fahrzeugtüren und -sitze als auch
        Elektromotoren und Elektronik, unter anderem für Lenkung, Bremsen,
        Getriebe und Motorkühlung. Rund 26.000 Mitarbeiter an 64 Standorten in
        24 Ländern erwirtschaften einen Umsatz von 6,3 Milliarden Euro. Jeder
        zweite Neuwagen weltweit ist mit mindestens einem Brose Produkt
        ausgestattet.
      </p>
      <h3>Warum setzen Sie in Ihrem Arbeitsprozess Video-Anleitungen ein?</h3>
      <p>
        Am Anfang stand die Suche nach einem einheitlichen Format für die
        Bereitstellung von Videos, die am Arbeitsplatz abgerufen werden können.
        Ein Vergleich von Lehr- und Lernmethoden brachte uns auf den
        Utilityfilm. Mit diesem können wir unsere Werksmitarbeiter direkt
        informieren und schulen. In einem nächsten Schritt ersetzen wir so auch
        Arbeitsanweisungen in Papierform. Außerdem nutzen wir die Filme für die
        Beschreibung von Qualitätsprozessen und Logistikabläufen sowie als
        Anleitungen für Software.
      </p>

      <h3>Warum haben Sie sich für video2manual als Software entschieden?</h3>
      <p>
        Auf der Suche nach einer alternativen Softwarelösung entstand der
        Kontakt zu ISB. Die erste Pilotstudie erfolgte bereits unter Verwendung
        von v2m. Die Software ist nah am Workflow und hat eine einfache und
        intuitive Bedienung. v2m lässt sich gut in die Brose-IT-Welt
        integrieren. Das Feedback der Anwender ist durchweg positiv. Bei
        Erweiterungswünschen und der Suche nach Lösungen neuer Aufgaben erhalten
        wir immer einen schnellen und hilfreichen Support von ISB.
      </p>

      <h3>video2manual in Aktion bei Brose:</h3>
      <img class="screenshot" src="assets/brose_workplace.png" />

      <h3>
        Wie lief die Zusammenarbeit mit ISB und die Lizenzvergabe für v2m ab?
      </h3>
      <p>
        Wir haben uns für ein Floating-Lizenz-Modell entschieden, das dem
        wechselnden Bedarf unserer weltweiten User gerecht wird. Schulungen
        erfolgen intern und größtenteils über Webinare. Wir legen bei der
        Auswahl unserer Key-User Wert auf eine gewisse „Video-Affinität“. Die in
        kleinen Pilot-/Start-Projekten an verschiedenen Standorten entstandenen
        Ideen und Wünsche zur Gestaltung von v2m wurden in enger Abstimmung mit
        ISB umgesetzt. Die Erfahrung von ISB in Sachen Dokumentation und
        bildlicher Darstellung kommt uns dabei immer wieder zu Gute.
      </p>

      <h3>Beispiel einer Video-Anleitung von Brose:</h3>
      <img class="screenshot" src="assets/brose_example.jpg" />
    </div>
    <div class="text" style="position: relative; height: 260px;">
        <hr/>
      <img src="assets/makareinis.jpg" style="width: 180px; position: absolute; left: 0;" />
      <p style="margin-left: 220px;">
        Durch die nette Zusammenarbeit mit Herrn Makareinis haben wir einige
        Einblicke in die Prozessoptimierung durch unsere Software video2manual
        erlangen können. Wir bedanken uns dafür vielmals!
      </p>
    </div>
  </article>
</section>
